<template>
  <div class="[&_p]:leading-relaxed">
    <slot />
  </div>
</template>
